var __TEMP__ = require('./identity.js');var identity = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = castFunction;
